export const LuminateColors = {
    blue: '#2A9DDC',
    accent: '#FFA210',
}